import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { cdpAiStore } from '../../../stores/cdpAiStore';

export const InputBar = observer((props: { pageContext?: string }) => {
  const { t, i18n } = useTranslation('console-ai');
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!cdpAiStore.draft.trim() || cdpAiStore.isSending) return;
    cdpAiStore.send(cdpAiStore.draft, { pageContext: props.pageContext, userLanguage: i18n.language });
  };
  return (
    <form onSubmit={onSubmit} className="border-t border-white/10 p-2">
      <input
        type="text"
        value={cdpAiStore.draft}
        onChange={e => cdpAiStore.setDraft(e.target.value)}
        placeholder={t('panel.placeholder')}
        disabled={cdpAiStore.isSending}
        className="w-full bg-white/5 border border-white/10 rounded px-2 py-1.5 text-sm focus:outline-none focus:border-sky-500/60"
      />
    </form>
  );
});
